import { PaginationHelper } from '@/helpers/paginationHelper'
import { AnnouncementDto } from '@/models/dtos/AnnouncementDto'
import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import axios from 'axios'
import { Endpoints } from './_endpoints'

export abstract class AnnouncementService {
  static async getAll(currentPage?: number, pageSize?: number): Promise<PagedResponseDto<AnnouncementDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const result = await axios
      .get<BaseResponseDto<PagedResponseDto<AnnouncementDto>>>(Endpoints.announcement.getAll,
        {
          params: {
            ...pagination
          }
        })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }
}
